import { Fragment } from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { Grid, Typography, Checkbox, Tooltip, IconButton } from "@mui/material";

import { Accept } from "../../css components/Button";
import { colors } from "../../css components/Style";
import { ButtonFooter, ComponentHeader, Paper } from "../../../components";

export default function FormDisplay({
  settings,
  formikProps,
  editState,
  setEditState,
  platformID,
}) {
  return (
    <Fragment>
      <Paper>
        <Grid size={12}>
          <ComponentHeader
            title={"Permission Setting"}
            subtitle={"Control the permission settings here"}
            buttons={[
              !editState && (
                <Accept
                  style={{ marginLeft: "5px" }}
                  size="large"
                  variant="contained"
                  onClick={() => setEditState(!editState)}
                >
                  Edit
                </Accept>
              ),
            ]}
          />
        </Grid>
        <Grid size={4}>
          <Typography variant="h4">Feature</Typography>
        </Grid>

        <Grid size={8}>
          <Typography variant="h4">Permission</Typography>
        </Grid>

        <Grid size={12} />
        {settings.map((setting) => (
          <Fragment key={setting.Id}>
            <Grid size={4}>
              <Typography variant="h5">
                {setting.setting_name}
                <Tooltip title={setting?.help_text || ""}>
                  <IconButton>
                    <FaRegQuestionCircle />
                  </IconButton>
                </Tooltip>
              </Typography>
            </Grid>

            <Grid size={8}>
              <Checkbox
                disabled={!editState}
                onChange={(e) => {
                  formikProps.setFieldValue(
                    setting.setting_key,
                    e.target.checked
                  );
                }}
                checked={formikProps.values[setting?.setting_key]}
                sx={{
                  padding: 0,
                  color: colors.purple,
                  "&.Mui-checked": {
                    color: colors.purple,
                  },
                }}
              />
            </Grid>
          </Fragment>
        ))}
      </Paper>

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            ID={platformID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Fragment>
  );
}
